export const SITE_INFO = {
  name: "Texoma Resorts",
  brandName: "Serenity Village",
  tagline: "Where Nature, Adventure & Relaxation Meet",
  address: "1642 FM1310, Denison, TX 75020, United States",
  phone: "+1 (214) 901-7378",
  phoneRaw: "+12149017378",
  email: "Douglaspstexas@gmail.com",
  facebook: "https://facebook.com/thakkarfamilyranch",
  maxGroupSize: 40,
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1761758594466-d122171620e7?w=1920&q=80&fit=crop",
  cabin1: "https://images.unsplash.com/photo-1769859271686-319af5f68a62?w=800&q=80&fit=crop",
  cabin2: "https://images.unsplash.com/photo-1760216455382-4220cf300a49?w=800&q=80&fit=crop",
  cabin3: "https://images.unsplash.com/photo-1761549148430-85b7abf00f33?w=800&q=80&fit=crop",
  dome1: "https://images.unsplash.com/photo-1769293633424-98f906e125e4?w=800&q=80&fit=crop",
  dome2: "https://images.unsplash.com/photo-1772423847112-c978f25f7a61?w=800&q=80&fit=crop",
  glamping1: "https://images.unsplash.com/photo-1762255097010-49e99eadd616?w=800&q=80&fit=crop",
  glamping2: "https://images.unsplash.com/photo-1762254944128-2aa92cf7089e?w=800&q=80&fit=crop",
  camping1: "https://images.unsplash.com/photo-1770893876530-68601a346202?w=800&q=80&fit=crop",
  camping2: "https://images.unsplash.com/photo-1602872250608-a17f7ba8933d?w=800&q=80&fit=crop",
  camping3: "https://images.unsplash.com/photo-1755554259222-08ec71b07f56?w=800&q=80&fit=crop",
  atv: "https://images.unsplash.com/photo-1736147936423-787f57fbfd4c?w=800&q=80&fit=crop",
  boat: "https://images.unsplash.com/photo-1590256447127-ab295475e413?w=800&q=80&fit=crop",
  boatAction: "https://images.unsplash.com/photo-1757467105489-795d5aee2e33?w=800&q=80&fit=crop",
  romantic: "https://images.unsplash.com/photo-1762328858893-05359f7add4a?w=800&q=80&fit=crop",
  yoga: "https://images.unsplash.com/photo-1758274526093-23bc5136933f?w=800&q=80&fit=crop",
  yoga2: "https://images.unsplash.com/photo-1758274526108-49b7e3fc05aa?w=800&q=80&fit=crop",
  sunset: "https://images.unsplash.com/photo-1761758594466-d122171620e7?w=1200&q=80&fit=crop",
  lakeActivity: "https://images.unsplash.com/photo-1727380460045-8a319df4c934?w=800&q=80&fit=crop",
  paddle: "https://images.unsplash.com/photo-1565969171718-0ee8eb2f5e90?w=800&q=80&fit=crop",
  gallery1: "https://le-de.cdn-website.com/9863cb6cd8c24c1b8f98b5e8a4557dee/dms3rep/multi/opt/675eacc1-31a4-4426-b812-a9b9eecf5fac-1920w.jpeg",
  gallery2: "https://le-de.cdn-website.com/9863cb6cd8c24c1b8f98b5e8a4557dee/dms3rep/multi/opt/9cb56aac-bf5b-448a-930f-1df290207769-1920w.jpeg",
  gallery3: "https://le-de.cdn-website.com/9863cb6cd8c24c1b8f98b5e8a4557dee/dms3rep/multi/opt/b63e35bc-a2e2-4df4-982f-798fa11ff16f-1920w.jpeg",
  gallery4: "https://le-de.cdn-website.com/9863cb6cd8c24c1b8f98b5e8a4557dee/dms3rep/multi/opt/IMG_6953-1920w.jpeg",
  gallery5: "https://le-de.cdn-website.com/9863cb6cd8c24c1b8f98b5e8a4557dee/dms3rep/multi/opt/IMG_6436-1920w.jpeg",
  gallery6: "https://le-de.cdn-website.com/9863cb6cd8c24c1b8f98b5e8a4557dee/dms3rep/multi/opt/IMG_6686-1920w.jpeg",
  gallery7: "https://le-de.cdn-website.com/9863cb6cd8c24c1b8f98b5e8a4557dee/dms3rep/multi/opt/IMG_6690-1920w.jpeg",
  gallery8: "https://le-de.cdn-website.com/9863cb6cd8c24c1b8f98b5e8a4557dee/dms3rep/multi/opt/IMG_6704-1920w.jpeg",
  homeDetail1: "https://le-de.cdn-website.com/9863cb6cd8c24c1b8f98b5e8a4557dee/dms3rep/multi/opt/d65a29ea-26a5-4554-b3a8-6c3055fc860b-1920w.jpg",
  homeDetail2: "https://le-de.cdn-website.com/9863cb6cd8c24c1b8f98b5e8a4557dee/dms3rep/multi/opt/99e6ef29-c9ea-4128-94fc-ecf4420965a0-1920w.jpg",
  homeDetail3: "https://le-de.cdn-website.com/9863cb6cd8c24c1b8f98b5e8a4557dee/dms3rep/multi/opt/c73919ad-6cfa-4c32-8461-b0e0cb27b201-1920w.jpg",
  homeDetail4: "https://le-de.cdn-website.com/9863cb6cd8c24c1b8f98b5e8a4557dee/dms3rep/multi/opt/a40a0ac8-9279-468e-bbfa-be0dc110372c-2-b34ac67d-1920w.jpg",
};

export const ACCOMMODATIONS = [
  {
    id: "bet-cabin",
    name: "Bet Cabin",
    slug: "/bet-cabin",
    tagline: "Our signature luxury cabin retreat",
    description: "Experience the best of lakeside living in our signature Bet Cabin. Fully furnished with modern amenities, a private deck, and stunning views of the surrounding nature.",
    capacity: "Up to 6 guests",
    image: IMAGES.cabin1,
    amenities: ["Full Kitchen", "Private Deck", "AC & Heating", "Wi-Fi", "BBQ Grill", "Fire Pit", "Parking"],
    highlights: ["Lake Views", "Pet Friendly", "Self Check-In"],
  },
  {
    id: "glamping",
    name: "Glamping Safari Tents",
    slug: "/glamping",
    tagline: "Luxury meets the great outdoors",
    description: "Our safari-style glamping tents bring the outdoors in with luxurious bedding, ambient lighting, and nature all around you. The perfect blend of adventure and comfort.",
    capacity: "Up to 4 guests",
    image: IMAGES.glamping1,
    amenities: ["Queen Bed", "Ambient Lighting", "Outdoor Seating", "Shared Bathhouse", "Fire Pit Access"],
    highlights: ["Stargazing", "Nature Immersion", "Campfire Access"],
  },
  {
    id: "domes",
    name: "Geodesic Domes",
    slug: "/domes-cabins",
    tagline: "A unique stay under the stars",
    description: "Our geodesic domes offer a one-of-a-kind experience with panoramic views of the Texas sky. Modern comforts meet architectural wonder.",
    capacity: "Up to 2 guests",
    image: IMAGES.dome1,
    amenities: ["Skylight View", "Queen Bed", "Climate Control", "Private Entry", "Outdoor Deck"],
    highlights: ["360 Views", "Romantic", "Instagram-Worthy"],
  },
  {
    id: "camping",
    name: "Camping Sites",
    slug: "/camping",
    tagline: "Classic outdoor camping near Lake Texoma",
    description: "Our gated, secure camping sites offer the traditional outdoor experience with modern conveniences. Perfect for families and groups who love nature.",
    capacity: "Varies by site",
    image: IMAGES.camping1,
    amenities: ["Fire Pit", "Picnic Table", "Restrooms", "Water Access", "Parking"],
    highlights: ["Stargazing", "Family Friendly", "Campfire Cooking"],
  },
];

export const EXPERIENCES = [
  {
    id: "atv_adventure",
    name: "ATV Adventure",
    description: "Explore scenic trails around Lake Texoma on a thrilling ATV ride through rugged terrain.",
    price: 75.00,
    duration: "2 hours",
    image: IMAGES.atv,
    category: "adventure",
  },
  {
    id: "speed_boat",
    name: "Speed Boat Experience",
    description: "Feel the rush of Lake Texoma with a private speed boat tour across open waters.",
    price: 125.00,
    duration: "1.5 hours",
    image: IMAGES.boat,
    category: "adventure",
  },
  {
    id: "romantic_package",
    name: "Romantic Anniversary Package",
    description: "Room decoration with roses, candles, balloons, and a celebration setup for your special occasion.",
    price: 199.00,
    duration: "Setup included",
    image: IMAGES.romantic,
    category: "romantic",
  },
  {
    id: "campfire_package",
    name: "Campfire Package",
    description: "Private campfire setup with s'mores kit, blankets, and firewood for a memorable evening.",
    price: 45.00,
    duration: "Evening",
    image: IMAGES.camping3,
    category: "nature",
  },
  {
    id: "stargazing",
    name: "Stargazing Experience",
    description: "Guided stargazing with telescopes under the clear Texas sky away from city lights.",
    price: 35.00,
    duration: "2 hours",
    image: IMAGES.camping1,
    category: "nature",
  },
  {
    id: "proposal_setup",
    name: "Proposal Weekend Setup",
    description: "Complete romantic proposal setup with decorations, flowers, and photographer coordination.",
    price: 349.00,
    duration: "Full weekend",
    image: IMAGES.homeDetail3,
    category: "romantic",
  },
];

export const TESTIMONIALS = [
  {
    id: 1,
    name: "Sarah & Michael",
    location: "Dallas, TX",
    rating: 5,
    text: "Our anniversary weekend at Serenity Village was absolutely magical. The Bet Cabin was stunning, and the romantic package setup took our breath away. We can not wait to come back!",
    type: "Romantic Getaway",
  },
  {
    id: 2,
    name: "The Thompson Family",
    location: "Austin, TX",
    rating: 5,
    text: "Best family vacation we have ever had! The kids loved the campfire and stargazing. The glamping tents were comfortable and unique. Lake Texoma is beautiful!",
    type: "Family Vacation",
  },
  {
    id: 3,
    name: "David R.",
    location: "Houston, TX",
    rating: 5,
    text: "We booked the entire resort for our family reunion and it was perfect. The team was incredibly accommodating. The ATV adventure was a highlight for everyone!",
    type: "Group Reunion",
  },
];

export const FAQ_ITEMS = [
  {
    question: "What is the check-in and check-out time?",
    answer: "Check-in is at 3:00 PM and check-out is at 11:00 AM. Early check-in or late check-out may be available upon request.",
  },
  {
    question: "Are pets allowed at Texoma Resorts?",
    answer: "Yes! We are a pet-friendly resort. Please let us know in advance if you are bringing a pet so we can ensure your accommodation is ready.",
  },
  {
    question: "How do I book an experience or add-on?",
    answer: "You can book experiences directly through our website on the Experiences page or contact us to add them to your reservation.",
  },
  {
    question: "Can we book the entire resort for a private event?",
    answer: "Absolutely! We can accommodate groups of up to 40 guests for private events, retreats, and celebrations. Contact us for group pricing.",
  },
  {
    question: "What should I bring for camping?",
    answer: "We recommend bringing your own tent, sleeping bags, flashlights, insect repellent, and personal toiletries. We provide fire pits, picnic tables, and restroom access.",
  },
  {
    question: "Is there Wi-Fi available?",
    answer: "Wi-Fi is available in our cabin and common areas. For glamping and camping sites, connectivity may be limited. We encourage you to disconnect and enjoy nature!",
  },
  {
    question: "What is the cancellation policy?",
    answer: "Cancellations made 7 or more days before check-in receive a full refund. Cancellations within 7 days are subject to a one-night charge. Please see our Policies page for details.",
  },
  {
    question: "How far is the resort from Lake Texoma?",
    answer: "We are located adjacent to Lake Texoma and Eisenhower State Park, just minutes from the water. Our location offers easy access to all lake activities.",
  },
];

export const NAV_LINKS = [
  { label: "Home", path: "/" },
  { label: "Accommodations", path: "/accommodations" },
  { label: "Camping", path: "/camping" },
  { label: "Experiences", path: "/experiences" },
  { label: "Retreats & Events", path: "/retreats" },
  { label: "Gallery", path: "/gallery" },
  { label: "FAQ", path: "/faq" },
  { label: "Contact", path: "/contact" },
];
